import { type CSSProperties } from 'react';

/**
 * PDF header3Column: flexDirection row, justifyContent space-between, alignItems center
 * headerSingleColumn: width 20%
 * pageHeaderImage: width 140pt -> 194px (scale 1.389)
 * pageName: textTransform uppercase, fontWeight 700, marginTop 10pt -> 14px
 *
 * Thumbnail (flex item, left edge) and text column (flex item, right edge) use `space-between`;
 * the logo is pulled OUT of that flex flow and absolutely centered on the header's full width,
 * so labeling a page / growing the right text column cannot push the logo off-centre (#734).
 */

export const PAGE_HEADER_OUTER_STYLE: CSSProperties = {
	position: 'relative',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'flex-start',
	flexShrink: 0,
	gap: '12px',
	paddingBottom: '18px'
};

export const PAGE_HEADER_THUMBNAIL_COL_STYLE: CSSProperties = {
	width: '194px',
	flexShrink: 0
};

// Max-bounded so a square/portrait thumbnail can't inflate the header; no object-fit (html2canvas 1.4.1 ignores it and stretches).
export const PAGE_HEADER_THUMBNAIL_IMG_STYLE: CSSProperties = {
	maxWidth: '194px',
	maxHeight: '110px',
	display: 'block'
};

export const PAGE_HEADER_LOGO_COL_STYLE: CSSProperties = {
	position: 'absolute',
	top: 0,
	left: '50%',
	transform: 'translateX(-50%)',
	flexShrink: 0
};

export const PAGE_HEADER_TEXT_COL_STYLE: CSSProperties = {
	textAlign: 'right',
	lineHeight: '1.4',
	textTransform: 'uppercase',
	fontSize: '16px'
};

export const PAGE_HEADER_NAME_STYLE: CSSProperties = { fontWeight: 700 };

export const PAGE_HEADER_TITLE_STYLE: CSSProperties = {
	textTransform: 'uppercase',
	fontWeight: 700,
	paddingTop: '14px',
	whiteSpace: 'nowrap'
};

export const RTA_LOGO_SVG_STYLE: CSSProperties = {
	width: '194px',
	height: 'auto',
	display: 'block'
};
